import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { DccProfileEntity } from "../../types/DccProfileEntity";
import { DccProfileDtoToEntity } from "../mappers/DccProfileDtoToEntity";
import { DccProfileEntityToDto } from "../mappers/DccProfileEntityToDto";

const DccProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DccProfileLoad: builder.query<DccProfileEntity, FormQuery>({
            providesTags: [ResourceName.DCC_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DCC_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return DccProfileDtoToEntity(response);
            },
        }),
        DccProfileSave: builder.mutation<DccProfileEntity, FormMutation<DccProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DCC_PROFILES}`;
                const method = "POST";

                const body = DccProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DCC_PROFILES],
        }),
        DccProfileUpdate: builder.mutation<DccProfileEntity, FormMutation<DccProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DCC_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = DccProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DCC_PROFILES],
        }),
    }),
});

export const { useDccProfileLoadQuery, useDccProfileSaveMutation, useDccProfileUpdateMutation } = DccProfileApi;
